export const geoCookieName = 'geoPopupWasShown';
